// extracted by mini-css-extract-plugin
export var aiStarSpin = "_s0-1";
export var spinner = "_s0-0";